
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Font } from "@/types/fonts";
import { configStore } from "@/store/store";

@Component
export default class BrandTypographyFont extends Vue {
  @Prop()
  label?: string;

  @Prop()
  description?: string;

  @Prop()
  value?: Font;

  update() {
    this.$emit("update", this.value);
  }

  get font() {
    return configStore.fonts.find(font => font.slug === this.value?.slug);
  }
}
